<template>
  <section class="background--views">
    <v-container>
      <component
        :is="component"
        :isEdit="isEdit"
        :item="item"
        @changeComponent="changeComponent"
        @edit="edit"
      ></component>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "Users",
  components: {
    UsersTable: () => import("../components/users/UsersTable.vue"),
    UserNew: () => import("../components/users/UserNew.vue"),
  },
  data: () => ({
    component: "UsersTable",
    isEdit: false,
    item: {},
  }),
  methods: {
    changeComponent(component) {
      if (component === "UsersTable") {
        this.isEdit = false;
        this.item = {};
      }
      this.component = component;
    },
    edit(user) {
      this.isEdit = true;
      this.item = user;
      this.component = "UserNew";
    },
  },
};
</script>
